// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1GzAG","col":"styles_col__1uKFz"};